var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-icon',{class:_vm.ThemeConfig.Icon,style:(_vm.buttonStyle)},[_vm._v(_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }